import { render, staticRenderFns } from "./AboutNatureMiracle.vue?vue&type=template&id=6ce86874&scoped=true"
import script from "./AboutNatureMiracle.vue?vue&type=script&lang=js"
export * from "./AboutNatureMiracle.vue?vue&type=script&lang=js"
import style0 from "./AboutNatureMiracle.vue?vue&type=style&index=0&id=6ce86874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce86874",
  null
  
)

export default component.exports